import { Component, ElementRef, HostListener, Input, ViewChild } from "@angular/core";

@Component({
    selector: "web-slider",
    templateUrl: "./slider.component.html",
    styleUrls: ["./slider.component.scss"],
})
export class SliderComponent {
    @Input() cardsLength = 0;
    @Input() gap = 0;
    @Input() visibleCards = 2; // default desktop
    index = 0;

    cardWidth = 0;
    step = 0;
    max = 0;

    startX = 0;
    lastX = 0;
    startTime = 0;
    velocity = 0;

    threshold = 50; // distance
    velocityThreshold = 0.5; // px/ms
    dragging = false;
    dragOffset = 0; // live drag movement
    baseTranslate = 0; // index * step

    @ViewChild("win", { static: true }) win!: ElementRef<HTMLDivElement>;

    ngAfterViewInit() {
        this.calc();
    }

    @HostListener("window:resize")
    onResize() {
        this.calc();
    }

    get translateX(): number {
        return -(this.index * this.step) + this.dragOffset;
    }

    calc() {
        const isMobile = window.innerWidth < 768;

        const cardsToShow = isMobile ? 1 : this.visibleCards;

        const w = this.win.nativeElement.offsetWidth;
        const totalGap = (cardsToShow - 1) * this.gap;

        this.cardWidth = (w - totalGap) / cardsToShow;
        this.step = this.cardWidth + this.gap;
        this.max = Math.max(this.cardsLength - cardsToShow, 0);

        if (this.index > this.max) this.index = this.max;
    }

    next() {
        if (this.index >= this.max) return;
        this.index++;
    }

    prev() {
        if (this.index <= 0) return;
        this.index--;
    }

    onStart(x: number) {
        this.dragging = true;
        this.startX = this.lastX = x;
        this.startTime = performance.now();
        this.dragOffset = 0;
    }

    onMove(x: number) {
        if (!this.dragging) return;

        const dx = x - this.lastX;
        const now = performance.now();
        const dt = now - this.startTime || 1;

        this.velocity = dx / dt;
        this.dragOffset += dx;
        this.lastX = x;

        // 🔒 Edge resistance
        if ((this.index === 0 && this.dragOffset > 0) || (this.index === this.max && this.dragOffset < 0)) {
            this.dragOffset *= 0.4;
        }
    }

    onEnd() {
        if (!this.dragging) return;

        const distance = -this.dragOffset;
        const speed = Math.abs(this.velocity);

        const canNext = this.index < this.max;
        const canPrev = this.index > 0;

        if (distance > this.threshold && canNext) {
            this.next();
        } else if (distance < -this.threshold && canPrev) {
            this.prev();
        }

        this.dragOffset = 0;
        this.dragging = false;
    }
}
